module.exports = __webpack_public_path__ + "img/pm.11614fc4.svg";